<via-error>
  <header>
    <h1>{{ "errors.video_too_large.title" | transloco }}</h1>
    <h5>{{ "errors.video_too_large.subtitle" | transloco }}</h5>
  </header>
  <via-error-actions></via-error-actions>
</via-error>
